import MailMagazineService from '../../ports/MailMagazineService';
import { updateUserUseCase } from '../user/update-user';
import { getAccessTokenUseCase } from './get-access-token';

export type registerToMailMagazineUseCase = (
  email: string,
  name: string,
  userId: string,
) => Promise<void>;

export const buildRegisterToMailMagazine = (dependencies: {
  mailMagazineService: MailMagazineService;
  authInteractor: { getAccessToken: getAccessTokenUseCase };
  userInteractor: { updateUser: updateUserUseCase };
}): registerToMailMagazineUseCase => {
  const {
    mailMagazineService,
    authInteractor: { getAccessToken },
    userInteractor: { updateUser },
  } = dependencies;

  const registerToMailMagazine: registerToMailMagazineUseCase = async (
    email: string,
    name: string,
    userId: string,
  ) => {
    try {
      const accessToken = await getAccessToken(userId);

      if (!accessToken) {
        throw { error_description: 'Did not receive access token' };
      }
      // Note: Uncomment line below to simulate error in registering to mail magazine
      // throw { Error: '500', error_description: 'System error' };
      const result = await mailMagazineService.registerToMailMagazine(
        accessToken,
        email,
        name,
      );

      if (!result) {
        await updateUser(userId, { hasFailedToRegisterToMailMagazine: true });
      }
    } catch (error) {
      await updateUser(userId, { hasFailedToRegisterToMailMagazine: true });
    }
  };

  return registerToMailMagazine;
};
